import displayError from '@/api/errors/errorResponse'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/forms/form/Form'
import FormWrap from '@/components/forms/form/FormWrap'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'

import { createDisplayService } from '@/api/services/displays/displaysService'
import { Input } from '@/components/forms/inputs/text/Input'
import { zodResolver } from '@hookform/resolvers/zod'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { z } from 'zod'

const inputSchema = z.object({
  name: z.string().min(1, 'Nazwa jest wymagana'),
  resolution: z.string().min(1, 'Rozdzielczość jest wymagana')
})

type InputSchema = z.infer<typeof inputSchema>

function DisplayCreate() {
  const [open, setOpen] = useState(false)
  const form = useForm<InputSchema>({
    resolver: zodResolver(inputSchema),
    defaultValues: {
      name: '',
      resolution: ''
    }
  })

  const queryClient = useQueryClient()

  const { mutate, isPending } = useMutation({
    mutationFn: (body: InputSchema) => createDisplayService(body),
    onSuccess: async (res) => {
      if (!res.success) return displayError(res)
      setOpen(false)
      await queryClient.invalidateQueries({ queryKey: ['displays'] })
      form.reset()
    }
  })

  const onSubmit = (data: InputSchema) => {
    mutate(data)
  }

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button>
          <Plus />
          Dodaj wyświetlacz
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby="Nowy wyświetlacz"
        aria-description="Nowy wyświetlacz"
      >
        <DialogHeader>
          <DialogTitle>Dodaj nowy wyświetlacz</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <FormWrap onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nazwa wyświetlacza</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Wpisz nazwę wyświetlacza..."
                      {...field}
                      // error={errors?.creationDescription}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="resolution"
              render={({ field }) => (
                <FormItem className="mt-4">
                  <FormLabel>Rozdzielczość wyświetlacza</FormLabel>
                  <FormControl>
                    <Input placeholder="Podaj rozdzielczość np. 1920x1080" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="mt-4 -mb-6 flex items-center justify-end">
              <Button disabled={isPending} type="submit">
                Dodaj
              </Button>
            </div>
          </FormWrap>
        </Form>
      </DialogContent>
    </Dialog>
  )
}

export default DisplayCreate
